<template>
  <div class="app-container">
    <el-button size="medium" type="primary" style="margin-bottom: 20px;" @click="dialogCreateVisible = true">Add</el-button>
    <el-table v-loading="listLoading" :data="list" fit highlight-current-row style="width: 100%">
      <el-table-column align="center" label="課堂編號" width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.number }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="課程" width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.courseTitle }}</span>
          <br>
          <span>{{ scope.row.courseNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="類型" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.courseTypeName }}</span><span v-if="scope.row.courseType==='group'">({{ scope.row.courseGroupMaxEnrollNum }})</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="定價" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.coursePrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="時間" width="100">
        <template slot-scope="scope">
          <el-button type="warning" size="small" @click="timeLists(scope.row.id, scope.row.number, scope.row.courseTitle, scope.row.lessonTimes)">點我查看</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" label="學生" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.students.length == 1">{{ scope.row.students[0].name }}</span>
          <span v-if="scope.row.students.length > 1">
            <el-button type="info" size="small" @click="studentLists(scope.row.number, scope.row.courseTitle, scope.row.students)">{{ scope.row.students.length }}人</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="老師" width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.teacherName }}</span>
          <br>
          <span>{{ scope.row.teacherNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-button v-if="scope.row.editable===true" type="success" size="small" @click="edit(scope.row)">編輯</el-button>
          <el-button v-if="scope.row.editable===true" type="danger" size="small" @click="remove(scope.row.number, scope.row.id)">刪除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
    <CreateDialog :dialog-create-visible-prop="dialogCreateVisible" />
    <EditDialog :dialog-edit-visible-prop="dialogEditVisible" />
    <TimeDialog :dialog-time-visible-prop="dialogTimeVisible" />
    <StudentDialog :dialog-student-visible-prop="dialogStudentVisible" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import CreateDialog from '@/views/events/main/create'
import EditDialog from '@/views/events/main/edit'
import TimeDialog from '@/views/events/main/time'
import StudentDialog from '@/views/events/main/student'
import EventResource from '@/api/event'
const eventResource = new EventResource()
export default {
  name: 'EventList',
  components: { Pagination, CreateDialog, EditDialog, TimeDialog, StudentDialog },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10
      },
      dialogCreateVisible: false,
      dialogEditVisible: false,
      dialogTimeVisible: false,
      currentTimeListLessonId: 0,
      currentTimeListLessonNumber: '',
      currentTimeListCourseTitle: '',
      currentTimeListData: [],
      dialogStudentVisible: false,
      currentStudentListLessonNumber: '',
      currentStudentListCourseTitle: '',
      currentStudentListData: [],
      statusOpitons: [
        { 'value': 'all', 'label': '全部' },
        { 'value': 'not_started', 'label': '未上課' },
        { 'value': 'finished', 'label': '已完課' }
      ],
      roomOptions: [],
      currentEditItem: null,
      currentEditId: 0,
      errorCodeMessage: {
        0: { 'type': 'success', 'title': ' Success', 'message': ' Success' },
        12: { 'type': 'error', 'title': 'Something went wrong', 'message': 'Please try again. (Error Code 12)' },
        13: { 'type': 'error', 'title': 'Something went wrong', 'message': 'Please try again. (Error Code 13)' },
        23: { 'type': 'warning', 'title': 'Warning', 'message': 'Please try again. (Error Code 23)' }
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.listLoading = true
      const { data } = await eventResource.getLessonList(this.listQuery)
      console.log(data)
      this.list = data.items
      this.total = data.total
      this.roomOptions = data.roomOptions
      this.listLoading = false
    },
    timeLists(lessonId, lessonNumber, courseTitle, times) {
      this.currentTimeListLessonId = lessonId
      this.currentTimeListLessonNumber = lessonNumber
      this.currentTimeListCourseTitle = courseTitle
      this.currentTimeListData = times
      this.dialogTimeVisible = true
    },
    studentLists(lessonNumber, courseTitle, students) {
      this.currentStudentListLessonNumber = lessonNumber
      this.currentStudentListCourseTitle = courseTitle
      this.currentStudentListData = students
      this.dialogStudentVisible = true
    },
    edit(item) {
      if (item) {
        this.currentEditItem = item
        this.dialogEditVisible = true
      }
    },
    remove(number, id) {
      this.$confirm('確定刪除? 課堂編號:' + number, 'Tip', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'
      }).then(() => {
        this.sendData(id)
      }).catch(() => {
        return false
      })
    },
    async sendData(id) {
      const { data } = await eventResource.removeLesson(id)
      const actionTitle = '刪除課堂'
      if (data.code === 0) {
        this.messageNotify(
          actionTitle,
          this.errorCodeMessage[data.code]['message'],
          this.errorCodeMessage[data.code]['type']
        )
        this.getList()
      } else {
        this.messageNotify(
          actionTitle,
          data.errors,
          'error'
        )
        return false
      }
    },
    handleFilter() {
      this.getList()
    },
    messageNotify(title, message, type) {
      this.$notify({
        title: title,
        dangerouslyUseHTMLString: true,
        message: `<div>${message}</div>`,
        type: type
      })
    }
  }
}
</script>

<style scoped>
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.el-table {
  position: inherit!important;
}
</style>
